import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/lib/i18n";

const FAQS = [
  { q: "How much does HVAC repair cost?", a: "Most repairs range from $150–$600 depending on the part and labor. We provide flat-rate quotes before any work begins — no surprises." },
  { q: "How long does installation take?", a: "Most residential AC or furnace installs are completed in 1 day. Mini split and zoned systems may take 1–2 days." },
  { q: "Do you offer emergency service?", a: "Yes — 24/7 emergency HVAC service is available throughout Southern California. Call us anytime at (626) 633-6408." },
  { q: "What brands do you service?", a: "All major HVAC brands including Carrier, Lennox, Goodman, Trane, Mitsubishi, LG, Midea, Fuji, and more." },
  { q: "How often should HVAC systems be maintained?", a: "We recommend twice a year — once before cooling season and once before heating season. Our membership plan includes both visits." },
  { q: "Should I repair or replace my HVAC system?", a: "If your system is 12+ years old, needs major repairs, or runs inefficiently, replacement often saves more in the long run. We'll give you the honest answer." },
];

export default function FAQ() {
  const { t } = useLang();
  return (
    <section id="faq" className="section-pad" data-testid="faq">
      <div className="mx-auto max-w-4xl px-5 md:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">FAQ</div>
        <h2 className="mt-3 font-display text-3xl md:text-5xl font-black">{t("faq.title")}</h2>

        <Accordion type="single" collapsible className="mt-8 rounded-2xl bg-ink-800 ring-1 ring-white/10 divide-y divide-white/5">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="px-5 border-0">
              <AccordionTrigger data-testid={`faq-q-${i}`} className="text-left font-display font-semibold text-base hover:no-underline">{f.q}</AccordionTrigger>
              <AccordionContent className="text-silver-300 text-sm leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
